import { useId } from "react";
import { EMBLEM_INNER, EMBLEM_OUTER } from "@/lib/emblemPaths";

export const Emblem = ({ className = "w-10 h-10", spin = false, glow = false }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="40 45 664 652" className={className} aria-label="Эмблема ТОО «БАСПАНА ҚҰРЫЛЫС ИНВЕСТ»" role="img">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFE3A3" />
          <stop offset="45%" stopColor="#E5A93C" />
          <stop offset="100%" stopColor="#B9811E" />
        </linearGradient>
      </defs>
      <path d={EMBLEM_OUTER} fill={`url(#g${id})`} fillRule="evenodd" className={spin ? "emblem-spin" : ""} />
      <path d={EMBLEM_INNER} fill={`url(#g${id})`} fillRule="evenodd" className={glow ? "emblem-glow" : ""} />
    </svg>
  );
};

export const LogoMark = ({ className = "w-9 h-9" }) => <Emblem className={className} />;

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="header-logo" className="flex items-center gap-3 text-[var(--text)] group">
    <span className="w-10 h-10 md:w-11 md:h-11 shrink-0 transition-transform duration-700 group-hover:rotate-[45deg]">
      <Emblem className="w-full h-full" />
    </span>
    <span className="flex flex-col leading-none text-left">
      <span className="font-display text-[15px] md:text-[17px] font-bold tracking-[0.04em]">БАСПАНА</span>
      <span className="font-display text-[9px] md:text-[10px] font-medium tracking-[0.18em] md:tracking-[0.32em] whitespace-nowrap text-[var(--gold)] mt-1.5">ҚҰРЫЛЫС ИНВЕСТ</span>
    </span>
  </button>
);
